/**
 * The single placeholder every not-yet-built destination renders.
 *
 * Eleven routes exist from the first commit so that the information
 * architecture is fixed on day one, but ten of their screens belong to later
 * phases. Rather than a 404 or a blank page -- either of which reads as broken
 * -- each names the capability and the phase that delivers it.
 *
 * It carries no logic and issues no data request. It is a sign, not a screen.
 */

import { Construction } from 'lucide-react';

import type { NavEntry } from '@/navigation/navigation';

export function PhasePlaceholder({ entry }: { entry: NavEntry }) {
  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">{entry.label}</h1>
          <div className="page-sub">{entry.summary}</div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="empty">
            <div className="e-icon">
              <Construction aria-hidden="true" />
            </div>
            <h3>Not built yet</h3>
            <p>
              This is a reserved destination. The navigation, routing and shell are
              in place from the first release so the application's structure does
              not change underneath you. The screen itself arrives with{' '}
              <strong>{entry.deliveredBy}</strong>.
            </p>
            <p style={{ marginTop: 'var(--space-4)' }}>
              <span className="badge badge-primary">{entry.deliveredBy}</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
